import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  inject,
  Inject,
  Injector,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  DecimalPipe,
  DOCUMENT,
  NgClass,
  NgOptimizedImage,
  NgStyle,
  TitleCasePipe,
} from '@angular/common';
import { ContainerModel } from '@app/models/server/layout.model';
import { SafePipe } from '@app/components/pipes/safe/safe.pipe';
import { RatingTypePipe } from '@app/components/pipes/rating-type/rating-type.pipe';
import { environment } from '@src/environments/environment';
import { RouterLink } from '@angular/router';
import { TapEffect } from '@app/components/directives/tap-effect.ts/tap-effect';

@Component({
  selector: 'app-b2b-short-property-card',
  templateUrl: './b2b-short-property-card.component.html',
  styleUrls: ['./b2b-short-property-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass,
    NgStyle,
    TitleCasePipe,
    SafePipe,
    NgOptimizedImage,
    DecimalPipe,
    RatingTypePipe,
    RouterLink,
    TapEffect,
  ],
})
export class B2bShortPropertyCardComponent implements OnInit {
  @Input() compData: {
    container: ContainerModel;
    pc1?: ContainerModel;
  };

  @Input() roomContainerKey: string = String('room_container');

  protected readonly environment = environment;

  filledStars: Array<number> = [];
  emptyStars: Array<number> = [];
  decimalStar: number;
  isFavorite = false;
  productStarRating: number;
  injector: Injector;
  isVisible = false;
  @ViewChild('popupRef') popupRef!: ElementRef;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private cdref: ChangeDetectorRef,
  ) {
    this.injector = inject(Injector);
  }

  ngOnInit() {
    if (this.compData?.container?.starRating) {
      this.productStarRating = Number(this.compData?.container?.starRating);
      if (!isNaN(this.productStarRating) && this.productStarRating > 0) {
        this.setupRatingData(this.productStarRating);
      }
    }

    if (this.compData?.container?.wishlistIds?.length > 0) {
      if (
        this.compData?.container?.wishlistIds?.includes(
          this.compData?.container?.groupUid,
        )
      ) {
        this.isFavorite = true;
      }
    }
  }

  toggleCertified(event: MouseEvent) {
    event.stopPropagation();
    this.isVisible = !this.isVisible;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.popupRef && !this.popupRef.nativeElement.contains(event.target)) {
      this.isVisible = false;
    }
  }

  gotoRooms() {
    this.document?.getElementById(this.roomContainerKey)?.scrollIntoView({
      behavior: 'smooth',
    });
  }

  setupRatingData(avgRating: number) {
    const filledStars: Array<number> = new Array(Math.floor(avgRating));
    const emptyStars: Array<number> = new Array(Math.floor(5 - avgRating));
    let decimalStar: number = avgRating - Math.floor(avgRating);
    if (decimalStar < 1 && decimalStar > 0) {
      decimalStar = Number(decimalStar.toFixed(1)) * 100;
    }
    this.filledStars = filledStars;
    this.decimalStar = decimalStar;
    this.emptyStars = emptyStars;
  }

  toggleFavorite() {
    import(
      '@app/services/util-services/lazy-services/wishlist-util.service'
    ).then((r) => {
      const s = this.injector.get(r.WISHLIST_UTIL_SERVICE);
      s.toggleFavorite(
        !this.isFavorite,
        this.compData?.container?.uid,
      ).subscribe((result: boolean) => {
        this.isFavorite = Boolean(result);
        this.cdref.markForCheck();
      });
    });
  }

  async openShareModal() {
    import('@app/services/util-services/lazy-services/share-util.service').then(
      (r) => {
        const s = this.injector.get(r.SHARE_UTIL_SERVICE);
        s.openShareModal(
          this.compData?.container?.displayName,
          this.compData?.container?.description,
          this.compData?.container?.image?.path,
          this.compData?.container?.finalSeoUrl,
        ).then();
      },
    );
  }

  gotoReviews() {
    // reviews_container
    this.document?.getElementById('reviews_container')?.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
